<template>
  <div class="k-product-card">
    <k-icon
      :icon="icon"
      class="k-product-icon"
    />
    <span class="title">
      {{title}}
    </span>
  </div>
</template>

<script>
import KIcon from './KIcon.vue';
export default {
  components: { KIcon },
  name: 'KProductCard',
  props: {
    title: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  },
};
</script>

<style lang='scss'>
@import "../assets/scss/main.scss";

.k-product-card {
  color: rgba($neutral-1, 0.8);
  width: 165px;
  height: 100px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: $neutral-2;
  transition: all ease 0.3s;
  font-size: 24px;
  .title {
    @include heading-6;
    align-self: flex-start;
  }
  .k-product-icon {
    align-self: flex-end;
  }
  &:hover {
    color: $neutral-1;
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/kaledo-components/src/components/KProductCard.vue